var dom, svg;

({dom, svg} = require('../odo/odojs/'));

module.exports = function(d, selected) {
  return dom('.page--normal', [
    dom('nav',
    [
      dom('a.nav--logo',
      {
        attributes: {
          href: '/'
        }
      },
      svg('svg',
      {},
      svg('use',
      {
        'xlink:href': '/assets.svg#logo-horizontal'
      }))),
      dom('ul',
      []),
      dom('ul.nav--right',
      [
        dom(`li${(selected === 'account' ? '.selected' : '')}`,
        dom('a',
        {
          attributes: {
            href: '/account'
          }
        },
        'Account'))
      ])
    ]),
    dom('hr'),
    d,
    dom('hr.secondary'),
    dom('footer',
    [
      dom('ul',
      [
        dom('li',
        dom('a',
        {
          attributes: {
            href: '/terms-of-use',
            rel: 'external'
          }
        },
        'Terms of Use')),
        dom('li',
        dom('a',
        {
          attributes: {
            href: '/privacy-policy',
            rel: 'external'
          }
        },
        'Privacy Policy')),
        dom('li',
        dom('a',
        {
          attributes: {
            href: '/contact',
            rel: 'external'
          }
        },
        'Contact Us'))
      ])
    ])
  ]);
};
